"use client"

import { useStaffFirmClaim } from "../model/use-staff-firm-claim"

/**
 * Mounted once in the root layout, inside `IdentityProvider` and above every
 * staff section's gate. Renders nothing: it claims the tab's one staff firm on
 * a staff-scope route (STAFF-G5b). See `useStaffFirmClaim` for why it cannot
 * live below a gate.
 */
export function StaffFirmClaimSync() {
  useStaffFirmClaim()
  return null
}
